import SkyscraperBackground from './SkyscraperBackground';

export default SkyscraperBackground;
